import { render, staticRenderFns } from "./VariableGridCosts.vue?vue&type=template&id=c6e08962&lang=pug&"
import script from "./VariableGridCosts.vue?vue&type=script&lang=ts&"
export * from "./VariableGridCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports